/* XGuidance Spin & Win — assets/xg-spin-wheel.js */
(function () {
  'use strict';
  var el = document.querySelector('[data-xgsw]'); if (!el) return;
  var d = el.dataset, EDITOR = d.editor === 'true';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var K = { done: 'xgsw_done', closed: 'xgsw_closed', pending: 'xgsw_pending' };
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }, del: function (k) { try { localStorage.removeItem(k); } catch (e) {} } };
  var $ = function (s) { return el.querySelector(s); }, $$ = function (s) { return Array.prototype.slice.call(el.querySelectorAll(s)); };
  var prizes = (d.prizes || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  if (prizes.length < 2) prizes = ['30% OFF', '10% OFF', '50% OFF', '5% OFF', '80% OFF', '10% OFF'];
  var win = Math.max(0, prizes.indexOf((d.win || '').trim()));
  var N = prizes.length, SEG = 360 / N, code = d.code || 'XG-818';
  var modal = $('.xgsw__modal'), rot = $('.xgsw__rot'), pointer = $('.xgsw__pointer');
  var spun = false, openState = false, lastFocus = null, muted = d.sound === 'false';
  if (muted) el.classList.add('is-muted');

  /* ---------- build the wheel (SVG) ---------- */
  var NS = 'http://www.w3.org/2000/svg';
  var mk = function (tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); if (parent) parent.appendChild(n); return n; };
  var svg = $('.xgsw__wheel');
  var defs = mk('defs', {}, svg);
  var gg = mk('linearGradient', { id: 'xgswGold', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
  [['0', '#fff6d6'], ['.45', '#f0c75e'], ['1', '#a8741c']].forEach(function (s) { mk('stop', { offset: s[0], 'stop-color': s[1] }, gg); });
  var rim = mk('linearGradient', { id: 'xgswRim', x1: '0', y1: '0', x2: '1', y2: '1' }, defs);
  [['0', '#fff1b8'], ['.35', '#c99532'], ['.65', '#f0c75e'], ['1', '#7a5212']].forEach(function (s) { mk('stop', { offset: s[0], 'stop-color': s[1] }, rim); });
  var PAL = ['#2a0b6e', '#1766be', '#6a16b8', '#129b9c', '#3b0f8f', '#008f52', '#2112be', '#0e6e8a'];
  var R = 96, pt = function (a, r) { var t = (a - 90) * Math.PI / 180; return [(r * Math.cos(t)).toFixed(3), (r * Math.sin(t)).toFixed(3)]; };
  for (var i = 0; i < N; i++) {
    var a0 = i * SEG - SEG / 2, a1 = i * SEG + SEG / 2, p0 = pt(a0, R), p1 = pt(a1, R);
    mk('path', { d: 'M0 0L' + p0[0] + ' ' + p0[1] + 'A' + R + ' ' + R + ' 0 0 1 ' + p1[0] + ' ' + p1[1] + 'Z', fill: i === win ? 'url(#xgswGold)' : PAL[i % PAL.length], stroke: 'rgba(255,241,184,.55)', 'stroke-width': '.7' }, rot);
    var g = mk('g', { transform: 'rotate(' + (i * SEG) + ')' }, rot);
    var parts = prizes[i].split(' '), t = mk('text', { class: 'xgsw__slice-t' + (i === win ? ' is-win' : ''), 'text-anchor': 'middle', x: '0', y: '-66' }, g);
    var t1 = mk('tspan', { x: '0', dy: '0', 'font-size': N > 8 ? '11' : '14' }, t); t1.textContent = parts[0];
    if (parts[1]) { var t2 = mk('tspan', { x: '0', dy: '11', 'font-size': '7.5', 'letter-spacing': '1' }, t); t2.textContent = parts.slice(1).join(' '); }
  }
  mk('circle', { r: R + 3, fill: 'none', stroke: 'url(#xgswRim)', 'stroke-width': '8' }, svg);
  mk('circle', { r: '30', fill: 'none', stroke: 'rgba(255,241,184,.5)', 'stroke-width': '1' }, rot);
  var bulbs = mk('g', {}, svg);
  for (var b = 0; b < 24; b++) { var bp = pt(b * 15, R + 3); mk('circle', { class: 'xgsw__bulb', cx: bp[0], cy: bp[1], r: '2.2' }, bulbs); }

  /* ---------- sound (Web Audio, no files) ---------- */
  var ac = null;
  var audio = function () { if (muted) return null; if (!ac) { var A = window.AudioContext || window.webkitAudioContext; if (!A) return null; ac = new A(); } if (ac.state === 'suspended') ac.resume(); return ac; };
  function tone(freq, t0, dur, type, vol, slideTo) {
    var c = audio(); if (!c) return;
    var o = c.createOscillator(), g = c.createGain(), t = c.currentTime + (t0 || 0);
    o.type = type || 'sine'; o.frequency.setValueAtTime(freq, t); if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t + dur);
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(vol || 0.1, t + 0.008); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(c.destination); o.start(t); o.stop(t + dur + 0.02);
  }
  var tick = function () { tone(1700, 0, 0.035, 'square', 0.045, 900); };
  function whoosh() {
    var c = audio(); if (!c) return;
    var len = c.sampleRate * 0.9, buf = c.createBuffer(1, len, c.sampleRate), ch = buf.getChannelData(0);
    for (var i = 0; i < len; i++) ch[i] = (Math.random() * 2 - 1) * (1 - i / len);
    var src = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain(), t = c.currentTime;
    f.type = 'bandpass'; f.frequency.setValueAtTime(300, t); f.frequency.exponentialRampToValueAtTime(2600, t + 0.8); f.Q.value = 1.2;
    g.gain.setValueAtTime(0.12, t); g.gain.exponentialRampToValueAtTime(0.0001, t + 0.9);
    src.buffer = buf; src.connect(f); f.connect(g); g.connect(c.destination); src.start(t);
  }
  function fanfare() {
    [523.25, 659.25, 783.99, 1046.5, 1318.5, 1567.98].forEach(function (f, i) { tone(f, i * 0.09, 0.5, 'triangle', 0.09); tone(f * 2, i * 0.09 + 0.02, 0.3, 'sine', 0.03); });
    [1046.5, 1318.5, 1567.98, 2093].forEach(function (f) { tone(f, 0.62, 1.2, 'sine', 0.05); });
  }

  /* ---------- confetti & sparkles ---------- */
  var cv = $('.xgsw__fx'), cx = cv.getContext('2d'), parts = [], fxRun = false;
  var CC = ['#f0c75e', '#fff6d6', '#15f2fc', '#00ff88', '#bb30fe', '#ffffff'];
  function sizeCv() { var r = modal.getBoundingClientRect(), dp = Math.min(2, window.devicePixelRatio || 1); cv.width = r.width * dp; cv.height = r.height * dp; cx.setTransform(dp, 0, 0, dp, 0, 0); }
  function burst(n, ox, oy) {
    if (RM) return; sizeCv();
    for (var i = 0; i < n; i++) {
      var a = Math.random() * Math.PI * 2, v = 3 + Math.random() * 9;
      parts.push({ x: ox, y: oy, vx: Math.cos(a) * v, vy: Math.sin(a) * v - 4, g: 0.22, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, w: 4 + Math.random() * 6, h: 3 + Math.random() * 4, c: CC[(Math.random() * CC.length) | 0], l: 0, m: 90 + Math.random() * 60, star: Math.random() < 0.25 });
    }
    if (!fxRun) { fxRun = true; requestAnimationFrame(fxLoop); }
  }
  function fxLoop() {
    var W = cv.width, H = cv.height; cx.clearRect(0, 0, W, H);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i]; p.l++; p.vy += p.g; p.vx *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
      if (p.l > p.m) { parts.splice(i, 1); continue; }
      cx.save(); cx.globalAlpha = Math.min(1, (p.m - p.l) / 30); cx.translate(p.x, p.y); cx.rotate(p.r); cx.fillStyle = p.c;
      if (p.star) { cx.beginPath(); for (var k = 0; k < 8; k++) { var rr = k % 2 ? 2 : 6; cx.lineTo(Math.cos(k * Math.PI / 4) * rr, Math.sin(k * Math.PI / 4) * rr); } cx.fill(); }
      else cx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      cx.restore();
    }
    if (parts.length) requestAnimationFrame(fxLoop); else { fxRun = false; cx.clearRect(0, 0, W, H); }
  }
  var wheelCenter = function () { var m = modal.getBoundingClientRect(), w = svg.getBoundingClientRect(); return [w.left - m.left + w.width / 2, w.top - m.top + w.height / 2]; };

  /* ---------- steps ---------- */
  function step(name) {
    $$('.xgsw__step').forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === name); });
    var f = $('.xgsw__step.is-active input, .xgsw__step.is-active button, .xgsw__step.is-active a');
    if (f && name !== 'spin') setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 350);
  }

  /* ---------- spin ---------- */
  var angle = 0;
  function spin() {
    if (spun) return; spun = true;
    $$('[data-xgsw-spin]').forEach(function (b) { b.disabled = true; });
    el.classList.add('is-spinning'); whoosh();
    var jitter = (Math.random() - 0.5) * SEG * 0.55;
    var target = 360 * (RM ? 1 : 7) + ((360 - win * SEG) % 360) + jitter;
    var start = null, dur = RM ? 600 : 6200, from = 0, lastIdx = 0;
    function frame(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur), e = 1 - Math.pow(1 - t, 4);
      angle = from + (target - from) * e;
      rot.setAttribute('transform', 'rotate(' + angle.toFixed(2) + ')');
      var idx = Math.floor((angle + SEG / 2) / SEG);
      if (idx !== lastIdx) { lastIdx = idx; tick(); pointer.classList.add('is-tick'); setTimeout(function () { pointer.classList.remove('is-tick'); }, 70); }
      if (t < 1) requestAnimationFrame(frame); else won();
    }
    requestAnimationFrame(frame);
  }
  function won() {
    el.classList.remove('is-spinning'); el.classList.add('is-won');
    fanfare(); var c = wheelCenter(); burst(170, c[0], c[1]);
    setTimeout(function () { var m = modal.getBoundingClientRect(); burst(90, m.width * 0.75, m.height * 0.3); }, 450);
    step('win');
  }

  /* ---------- email + code ---------- */
  var form = $('.xgsw__form'), err = $('[data-xgsw-err]');
  function success() {
    ls.set(K.done, '1'); ls.del(K.pending); ls.del(K.closed);
    step('code');
    var m = modal.getBoundingClientRect(); burst(140, m.width / 2, m.height * 0.35);
    if (!muted) tone(1318.5, 0, 0.6, 'triangle', 0.08), tone(1760, 0.1, 0.8, 'sine', 0.05);
    if (d.apply === 'true') {
      fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2F', { credentials: 'same-origin', redirect: 'manual' })
        .then(function () { var ap = $('[data-xgsw-applied]'); if (ap) ap.hidden = false; }).catch(function () {});
    }
  }
  if (form) form.addEventListener('submit', function (e) {
    var inp = form.querySelector('input[type="email"]');
    if (!inp.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value)) { e.preventDefault(); err.hidden = false; inp.focus(); return; }
    err.hidden = true; ls.set(K.pending, '1');
    if (!window.fetch || !window.FormData) return; // normal submit, handled on reload
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]'); btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (/\/challenge/.test(r.url || '')) { form.submit(); return; } // Shopify asks for a captcha → do the normal submit
        success();
      })
      .catch(function () { form.submit(); });
  });
  var copyBtn = $('[data-xgsw-copy]');
  if (copyBtn) copyBtn.addEventListener('click', function () {
    var ok = function () { var t = copyBtn.textContent; copyBtn.textContent = copyBtn.dataset.done || 'Copied!'; setTimeout(function () { copyBtn.textContent = t; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok);
    else { var r = document.createRange(); r.selectNodeContents($('[data-xgsw-code]')); var s = window.getSelection(); s.removeAllRanges(); s.addRange(r); try { document.execCommand('copy'); } catch (x) {} ok(); }
  });

  /* ---------- open / close ---------- */
  var prevOverflow = '';
  function open(atStep) {
    if (openState) return; openState = true; lastFocus = document.activeElement;
    el.hidden = false; void el.offsetWidth; el.classList.add('is-open');
    prevOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
    step(atStep || 'spin');
    setTimeout(function () { try { modal.focus({ preventScroll: true }); } catch (e) {} }, 60);
    if (atStep === 'code') { spun = true; rot.setAttribute('transform', 'rotate(' + ((360 - win * SEG) % 360) + ')'); el.classList.add('is-won'); }
  }
  function close(remember) {
    if (!openState) return; openState = false;
    el.classList.remove('is-open'); document.documentElement.style.overflow = prevOverflow;
    setTimeout(function () { if (!openState) el.hidden = true; }, 500);
    if (remember && !EDITOR && ls.get(K.done) !== '1') ls.set(K.closed, String(Date.now()));
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  $$('[data-xgsw-close]').forEach(function (b) { b.addEventListener('click', function () { close(true); }); });
  $$('[data-xgsw-spin]').forEach(function (b) { b.addEventListener('click', spin); });
  var mb = $('[data-xgsw-mute]');
  if (mb) mb.addEventListener('click', function () { muted = !muted; el.classList.toggle('is-muted', muted); mb.setAttribute('aria-pressed', muted ? 'true' : 'false'); });
  el.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(true); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), a[href], input')).filter(function (x) { return x.offsetParent !== null; });
    if (!f.length) return; var first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  });

  /* ---------- when to show ---------- */
  if (EDITOR) {
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(el)) { spun = false; $$('[data-xgsw-spin]').forEach(function (b) { b.disabled = false; }); el.classList.remove('is-won'); open('spin'); } });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(el)) close(false); });
    return;
  }
  if (d.enabled !== 'true') return;
  if (ls.get(K.pending) === '1' && /customer_posted=true/.test(location.search)) { open('code'); success(); return; }
  if (ls.get(K.done) === '1') return;
  var closedAt = parseInt(ls.get(K.closed), 10) || 0, days = parseFloat(d.days) || 1;
  if (closedAt && Date.now() - closedAt < days * 864e5) return;
  var mn = parseFloat(d.min) || 10, mx = parseFloat(d.max) || 60; if (mx < mn) { var tmp = mn; mn = mx; mx = tmp; }
  var delay = (mn + Math.random() * (mx - mn)) * 1000;
  var params = new URLSearchParams(location.search); if (params.has('xgspin')) delay = 300;
  setTimeout(function () { if (!document.hidden) open('spin'); else document.addEventListener('visibilitychange', function once() { if (!document.hidden) { document.removeEventListener('visibilitychange', once); open('spin'); } }); }, delay);
})();
